import React, { useState, useLayoutEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Icon from 'relements/build/esm/ui/icon';
import Box from 'relements/build/esm/ui/box';

import { toggleBoolean } from '@src/utils/fp';
import { TopBar, Iframe, Container } from './styledComponents';
import { transitionDuration } from './const';

const IframeOverlay = ({ src }) => {
  const ref = useRef();
  const topBarRef = useRef();
  const [top, setTop] = useState(0);
  const [width, setWidth] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  useLayoutEffect(() => {
    setTop(topBarRef.current.offsetTop);
    // ref.current will change by the time cleanup function runs, so copy the pointer.
    const element = ref.current;

    setWidth(element.parentElement.offsetWidth);
    const resizeObserver = new ResizeObserver(() => {
      setWidth(element.parentElement.offsetWidth);
    });

    resizeObserver.observe(element.parentElement);
    return () => resizeObserver.unobserve(element.parentElement);
  }, []);

  return (
    <Container
      ref={ref}
      top={top}
      width={width}
      isExpanded={isExpanded}
      isAnimating={isAnimating}
      transitionDuration={transitionDuration}
    >
      <TopBar isExpanded={isExpanded} ref={topBarRef}>
        <Box marginRight="md" padding="md">
          <Icon
            src={isExpanded ? 'shrink' : 'expand'}
            onClick={() => {
              setIsExpanded(toggleBoolean);
              setIsAnimating(true);
              if (!isExpanded) setTop(topBarRef.current.offsetTop);
              setTimeout(() => {
                setIsAnimating(false);
              }, [2 * transitionDuration]);
            }}
          />
        </Box>
      </TopBar>
      <Iframe src={src} />
    </Container>
  );
};

IframeOverlay.propTypes = {
  src: PropTypes.string.isRequired,
};

export default React.memo(IframeOverlay);
